import React from 'react';

export const GuideIcon = props => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 18 18'
      fill='#FFFFFF'
      {...props}
    >
      <path d='M12.23,5.45l-2.54,2.46-.68,.66v7.15l3.61-3.49c.14-.13,.21-.31,.21-.5V5.7c0-.09-.04-.18-.1-.24-.13-.14-.36-.14-.49,0Z' />
      <path d='M9,0C4.03,0,0,4.03,0,9s4.03,9,9,9,9-4.03,9-9S13.97,0,9,0Zm5.79,11.97c0,.57-.23,1.11-.64,1.51l-4.18,4.04c-.54,.52-1.4,.52-1.95,0L3.84,13.48c-.41-.4-.64-.94-.64-1.51V3.52c0-.36,.14-.7,.39-.96,.53-.56,1.42-.58,1.98-.04l3.43,3.31,3.43-3.31c.26-.25,.6-.39,.96-.39,.77,0,1.41,.62,1.41,1.39V11.97Z' />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/icons/GuideIcon.jsx